/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activitySearchIds} from '../api'

export const useMutationActivitySearchIds = createReactQueryMutationHook('activitySearchIds', activitySearchIds)
